import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsSmFdrList from "../created-inner-pages/fdr-list";
import TmsFdrCreation from "../creation-inner-pages/tms-fdr-creation";
const FdrCreationIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New FDR Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsSmFdrList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"FDR Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsFdrCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default FdrCreationIndex;
